import { AppRouter } from './core/router/AppRouter';

export default function App() {
  return <AppRouter />;
}
